import {h, Fragment} from "preact"
import Product from './Product'
import { useAppState } from '@nosto/preact'
import { useState, useEffect } from 'preact/hooks'

export default ({ isMobile }) => {
    const [customer, setCustomer] = useState(false);
    const {
        response: { products },
        loading,
    } = useAppState()

    useEffect(() => {
        yotpo.refreshWidgets()
        jQuery('.header__search').removeClass('active--search')
        jQuery('.site-header__link--close-icon').trigger('click')
        jQuery('body, html').removeClass('noscroll')
    })

    useEffect(() => {
        if (window.AP_DATA_ISLOGIN === "Y") {
            setCustomer(true);
        }
    }, []);

    useEffect(() => {
        document.head.innerHTML +=
            '<link rel="stylesheet" href="https://us.innisfree.com/cdn/shop/t/826/assets/collection.min.css" type="text/css"/>'
        setTimeout(() => {
            jQuery('#nosto-products-grid').css('display', 'flex')
            jQuery('#nosto-products-grid').fadeTo('slow', 1)
        }, 200)

        // jQuery('.ns-serp .quick-add__swatch')
        //     .not('.nosto-link')
        //     .on('click', function (e) {
        //         e.preventDefault()
        //         let imgUrl = jQuery(this).attr('nosto-img')
        //         let price = jQuery(this).attr('data-price').replace('.00', '')
        //         jQuery(this)
        //             .closest('.product-tile')
        //             .find('.id-input')
        //             .attr('value', jQuery(this).prev().attr('value'))
        //         jQuery(this).closest('.product-tile').find('.nosto-img').attr('src', imgUrl)
        //         jQuery(this).closest('.product-tile').find('.nosto-price-atc').html(price)

        //         // changing is-active classes
        //         jQuery(this).closest('.product-tile').find('.is-active').removeClass('is-active')
        //         jQuery(this).addClass('is-active')
        //     })

        // jQuery('.ns-serp .quick-add__submit')
        //     .not('.nosto-bundle-url')
        //     .on('click', function (e) {
        //         console.log("clicked")
        //         e.preventDefault()
        //         var prodId = jQuery(this).closest('.form--product').find('.id-input').attr('value')
        //         theme.cart
        //             .add({ id: prodId, quantity: 1 })
        //             .then((cart) => theme.cartUI.refresh(null, cart.items))
        //         if (jQuery('.cart--flyout').hasClass('cart--empty')) {
        //             jQuery('.cart--flyout').removeClass('cart--empty')
        //         }
        //         setTimeout(() => {
        //             jQuery('.site-header__link.site-header__link--cart-icon').click()
        //         }, 500)
        //     })
    }, [])

    return (
        <div class="collection__products" id="nosto-products-grid" style="opacity: 0;">
            {products.hits.map((hit, index) => {
                return <Product isMobile={isMobile} product={hit} isCustomer={customer} key={hit.productId || index} />
            })}
        </div>
    )
}
